"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CollapsedCartView_1 = require("./CollapsedCartView");
exports.default = CollapsedCartView_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/CollapsedCartView/index.js
// module id = 787
// module chunks = 8